import { useEffect, useState, useRef } from 'react';
import { X, TrendingDown, TrendingUp, Bell } from 'lucide-react';

const NotificationCenter = ({ notifications, loading, onLoadMore, onMarkRead, onViewVehicle, onClose, pagination }) => {
  const [page, setPage] = useState(1);
  const panelRef = useRef(null);

  useEffect(() => {
    const unreadIds = notifications.filter(n => !n.is_read).map(n => n.id);
    if (unreadIds.length) onMarkRead(unreadIds);
  }, [notifications, onMarkRead]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const handleLoadMore = () => {
    const next = page + 1;
    setPage(next);
    onLoadMore(next);
  };

  const hasMore = pagination && page < pagination.total_pages;

  return (
    <div ref={panelRef} className="absolute right-0 top-full mt-2 w-80 max-h-[70vh] overflow-y-auto rounded-lg border border-[#2a2926] bg-[#1c1c1a] shadow-xl z-50">
      <div className="flex items-center justify-between p-3 border-b border-[#2a2926]">
        <h3 className="text-sm font-medium text-[#e8e4de]">Notificaciones</h3>
        <button onClick={onClose} className="text-[#8a8577] hover:text-[#e8e4de]"><X className="w-4 h-4" /></button>
      </div>
      {notifications.length === 0 ? (
        <div className="p-6 text-center text-[#8a8577]">
          <Bell className="w-8 h-8 mx-auto mb-2 opacity-50" />
          <p className="text-sm">Sin notificaciones</p>
        </div>
      ) : (
        <div>
          {notifications.map(n => {
            const isDown = n.price_change_percent < 0;
            return (
              <button key={n.id} onClick={() => onViewVehicle(n.vehicle_id)} className={`w-full text-left p-3 border-b border-[#2a2926] hover:bg-[#2a2926] transition-colors ${!n.is_read ? 'bg-[#232321]' : ''}`}>
                <p className="text-xs text-[#e8e4de] font-medium truncate">{n.title}</p>
                <div className="flex items-center gap-1.5 mt-1">
                  {isDown ? <TrendingDown className="w-3.5 h-3.5 text-[#48a877]" /> : <TrendingUp className="w-3.5 h-3.5 text-[#c75d5d]" />}
                  <span className="text-xs text-[#8a8577]">${n.old_price?.toLocaleString()} → ${n.new_price?.toLocaleString()}</span>
                  <span className={`text-xs font-medium ${isDown ? 'text-[#48a877]' : 'text-[#c75d5d]'}`}>
                    {isDown ? '' : '+'}{n.price_change_percent?.toFixed(1)}%
                  </span>
                </div>
                <p className="text-[10px] text-[#8a8577] mt-1">{new Date(n.created_at).toLocaleDateString()}</p>
              </button>
            );
          })}
          {hasMore && (
            <button onClick={handleLoadMore} disabled={loading} className="w-full p-2.5 text-xs text-[#8a8577] hover:text-[#e8e4de] hover:bg-[#2a2926] transition-colors disabled:opacity-50">
              {loading ? 'Cargando...' : 'Cargar más'}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationCenter;
